import Api from "./Api";
import Csrf from "./Csrf";

export default {

    /**
    * Register new User
    */
    async register(form) {
        await Csrf.getCookie();
    	return Api.post("/register", form);
  	},

    /**
    * Change Email
    */
    changeEmail(form) {
      return Api.post("/settings/email", form);
    },

    /**
    * Change Password
    */
    changePassword(form) {
      return Api.post("/settings/password", form);
    }
};